import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { NearbyVisibilityScope } from '../../queries/types/nearbyTypes'

interface UpdateNearbyVisibilityData {
  scope?: NearbyVisibilityScope
}

const updateNearbyVisibility = async (data: UpdateNearbyVisibilityData) => {
  const { data: result } = await api.put('/ft_nearby-visibility', data)
  return result
}

export const useUpdateNearbyVisibility = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateNearbyVisibility,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ft-nearby-visibility'] })
    },
  })
}
